import template from './add_objective_plan.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Permissions from '../../lib/permission_utils';
import * as PerfManage from '../../lib/performance_management_functions.js';

class AddObjectivePlanViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.title = ko.observable();
		this.objective_plan_id = ko.observable();
		//this.date = ko.observable(moment().format('YYYY-MM-DD'));
		this.employment_info = ko.observable();
		this.due_date = ko.observable();
		this.today = ko.observable(new Date().toISOString().split('T')[0]);
		this.objective_plan = ko.observable();
		this.objective_name = ko.observable();
		this.description = ko.observable();
		this.setup_date = ko.observable();
		this.selected_performance_cycle = ko.observable();
		this.cycle_dates = ko.observable();
		this.current_step = ko.observable();
		this.current_step_sequence = ko.observable();
		this.current_step_status = ko.observable();
		this.performance_cycles = ko.observableArray();
		this.selected_rating_system = ko.observable();
		this.rating_systems = ko.observableArray();
		this.step_status_options = ko.observableArray();
		this.cycle_steps_options = ko.observableArray();
		this.edit = ko.observable(false);
		this.rating_types = ko.observableArray(['single-select', 'multiselect', 'range', 'input', 'number' ]);
		this.selected_rating_type = ko.observable();
		this.cycle_changed = ko.observable(false);
		this.status = ko.observable('Not Started');
		this.total_steps = ko.observable(0);
		this.objectives = ko.observable();
		this.add_peer_group = ko.observable(false);
		this.peer_group = ko.observableArray();
		this.selected_group = ko.observable();

		// Add peer group employee management observables
		this.available_employees = ko.observableArray([]);
		this.peer_group_employees = ko.observableArray([]);
		this.selected_available_employees = ko.observableArray([]);
		this.selected_group_employees = ko.observableArray([]);

		// Add feature access observable
		this.has_admin_access = ko.observable(false);

		this.loading_edit_mode = ko.observable(false);

		this.logged_in_employee = ko.observable(parseInt(localStorage.getItem('employee_id')));
    	this.showing_feedback = ko.observable(localStorage.getItem('showing_objective_feedback') || false);
    	this.manager_id = ko.observable();
    this.measures = ko.observableArray();
    
    // Initialize rules observable with default values
    this.rules = ko.observable({
        all_fields_everyone: true,
        all_fields_employee: true,
        name_description: true,
        outcomes_measures: true,
        feedback_manager: true,
        feedback_employee: true,
        peer_feedback: true,
        setup_peer_reviewer: true,
        add_objectives: true,
        linked_company_objectives: false
    });
    
    this.objective_status_list = [
        { status: 'New' },
        { status: 'In Progress' },
        { status: 'Obsolete' },
        { status: 'On Hold' },
        { status: 'Finished' }
    ];
	
    	// Add computed observables
    	this.is_logged_in = ko.computed(() => {
    	    return this.logged_in_employee() === this.employment_info()?.employee_id;
    	}, this);
	
    	this.is_manager = ko.computed(() => {
    	    const loggedInId = this.logged_in_employee();
    	    const managerId = this.manager_id();
    	    return loggedInId && managerId && loggedInId === managerId;
    	}, this);
	
    	this.canAddObjectives = ko.computed(() => {
    	    return this.rules().add_objectives;
    	}, this);
	
    	this.showing_feedback.subscribe((val) => {
    	    localStorage.setItem('showing_objective_feedback', val);
    	});

		// Computed observables for display names
		this.available_employee_names = ko.computed(() => {
			return this.available_employees().map(emp => `${emp.firstname} ${emp.surname}`);
		});

		this.current_group_employees = ko.computed(() => {
			return this.peer_group_employees().map(emp => `${emp.firstname} ${emp.surname}`);
		});

		// Computed observable for the available employees header text
		this.available_employees_header = ko.computed(() => {
			return this.has_admin_access() ? 
				'Available employees' : 
				'Available employees (same department)';
		});

		this.selected_rating_type.subscribe((val) => {
			this.dialog.updateData();
		});

		this.current_step_sequence.subscribe((val) => {
			this.update_status();
		});

		// Subscribe to selected peer group changes
		this.selected_group.subscribe((val) => {
		    // Don't load if we're in edit mode initialization
		    if (this.loading_edit_mode()) return;

		    if (this.selected_group()) {
		        this.load_peer_group_employees();
		    }
		});

		this.add_peer_group.subscribe((val) => {
		    if (val) {
		        // If no peer group is selected, load employees based on admin access
		        if (!this.selected_group()) 
		            this.load_department_employees();
		    } else {
		        // Don't clear employee lists when in edit mode during initialization
		        if (!this.loading_edit_mode()) {  // Add () here too
		            this.available_employees([]);
		            this.peer_group_employees([]);
		            this.selected_available_employees([]);
		            this.selected_group_employees([]);
		        }
		    }
		});
		
		this.rating_placeholder = ko.computed(() => {
			if (!this.rating_systems().length > 0)
				return 'None available';
		});

		this.cycle_placeholder = ko.computed(() => {
			if (!this.performance_cycles().length > 0)
				return 'None available';
		});

	this.available_employee_names = ko.computed(() => {
			if (!this.has_admin_access()) {
				// Non-admin users see anonymized names
				return this.available_employees().map((emp, index) => `Employee ${index + 1}`);
			}
			return this.available_employees().map(emp => `${emp.firstname} ${emp.surname}`);
		});

		this.current_group_employees = ko.computed(() => {
			if (!this.has_admin_access()) {
				// Non-admin users see anonymized names
				return this.peer_group_employees().map((emp, index) => `Peer ${index + 1}`);
			}
			return this.peer_group_employees().map(emp => `${emp.firstname} ${emp.surname}`);
		});

		// Updated subscription to selected_performance_cycle to automatically populate peers
		this.selected_group.subscribe((val) => {
		    if (this.loading_edit_mode) return;

		    if (this.selected_group()) {
		        this.load_peer_group_employees();
		    }
		});

		 this.showing_feedback.subscribe((val) => {
    	    localStorage.setItem('showing_objective_feedback', val);
    	});

		this.selected_performance_cycle.subscribe((val) => {
		    if (val) {
		        this.dialog.get_cycle_dates(val);
		    }
		});
	};

	// Initialize feature access check
	async init_feature_access() {
		try {
			this.has_admin_access(await Permissions.checkAccessRights('PerformanceManagementAdmin'));
		} catch (error) {
			console.error('Error checking feature access:', error);
			this.has_admin_access(false);
		}
	}

	getUpStatus(objective) {
	    const currentStatus = objective.status();
	    const statusFlow = {
	        'New': 'In Progress',
	        'In Progress': 'Finished',
	        'On Hold': 'In Progress',
	        'Obsolete': null
	    };
	    return statusFlow[currentStatus] || null;
	}
	
	getDownStatus(objective) {
	    const currentStatus = objective.status();
	    const statusFlow = {
	        'In Progress': 'On Hold',
	        'Finished': 'In Progress'
	    };
	    return statusFlow[currentStatus] || null;
	}
	
	async changeStatusUp(objective) {
	    const newStatus = this.getUpStatus(objective);
	    if (newStatus) {
	        await this.updateObjectiveStatusInDB(objective, newStatus);
	    }
	}
	
	async changeStatusDown(objective) {
	    const newStatus = this.getDownStatus(objective);
	    if (newStatus) {
	        await this.updateObjectiveStatusInDB(objective, newStatus);
	    }
	}
	
	async updateObjectiveStatus(objective) {
	    const newStatus = objective.selected_status();
	    if (newStatus && newStatus !== objective.status()) {
	        await this.updateObjectiveStatusInDB(objective, newStatus);
	        objective.toggleStatusUpdate();
	    }
	}
	
	async updateObjectiveStatusInDB(objective, newStatus) {
	    try {
	        let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
	            objective_id: objective.objective_id,
	            objective_status: newStatus
	        });
		
	        if (res.status === 'ERROR') {
	            Grape.alerts.apiError(res);
	        } else if (res.status === 'OK') {
	            objective.status(newStatus);
	            objective.selected_status(newStatus);
	            Grape.alerts.alert({
	                type: 'success', 
	                message: `Objective status updated to ${newStatus}`
	            });
	        } else {
	            Grape.alerts.alert({
	                type: 'error', 
	                message: 'An error occurred while updating objective status'
	            });
	        }
	    } catch (error) {
	        console.error('Error updating objective status:', error);
	        Grape.alerts.alert({
	            type: 'error', 
	            message: 'An error occurred while updating objective status'
	        });
	    }
	}
	
	viewStatusHelp() {
	    Grape.alerts.alert({
	        type: 'warning',
	        title: 'Objective Status Definitions',
	        message: `
	            <strong>New:</strong> Objective has been created but work hasn't started<br>
	            <strong>In Progress:</strong> Work on the objective is currently underway<br>
	            <strong>On Hold:</strong> Work has been temporarily paused<br>
	            <strong>Obsolete:</strong> Objective is no longer relevant or needed<br>
	            <strong>Finished:</strong> Objective has been completed successfully
	        `
	    });
	}
	
	async btn_add_objective_to_plan() {
	    await Grape.dialog.open('AddToObjectivePlan', { 
	        employee_info: this.employment_info(), 
	        data: this.objective_plan()
	    });
	    this.dialog.get_obj_details(this.objective_plan());
	}
	
	async btn_edit_an_objective(data) {
	    if (data.editing()) {
	        let response = await Grape.alerts.confirm({
	            type: 'warning', 
	            title: 'Confirm', 
	            message: 'Are you sure want to save changes to this objective?'
	        });
	        if (response) {
	            try {
	                let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
	                    objective_id: data.objective_id,
	                    name: data.name,
	                    description: data.description,
	                    expected_result: data.expected_result,
	                    measure: data.measure
	                });
	                if (res.status == 'ERROR')
	                    Grape.alerts.apiError(res);
	                else if (res.status == 'OK')
	                    this.dialog.get_obj_details(this.objective_plan());
	                else
	                    Grape.alerts.alert({type: 'error', message: 'An error occurred while attempting to save changes to this objective.'});
	            } catch (error) {
	                console.error(error);
	                Grape.alerts.alert({type: 'error', message: 'An error occurred while attempting to save changes to this objective.'});
	            }
	        }
	    } else {
	        data.editing(!data.editing());
	    }
	}
	
	async btn_edit_emp_feedback(data) {
	    if (data.editing_emp_feedback()) {
	        let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/edit', {
	            objective_id: data.objective_id,
	            employee_id: this.employment_info().employee_id,
	            feedback: data.employee_feedback
	        });
	        if (res.status == 'ERROR')
	            Grape.alerts.apiError(res);
	        if (res.status == 'OK') {
	            Grape.alerts.alert({type: 'success', message: 'Successfully updated your feedback.'});
	            this.dialog.get_obj_details(this.objective_plan());
	            data.editing_emp_feedback(!data.editing_emp_feedback());
	        } else
	            Grape.alerts.alert({type: 'error', message: 'An error occurred while updating feedback.'});
	    } else {
	        data.editing_emp_feedback(!data.editing_emp_feedback());
	    }
	}
	
	async btn_edit_manager_feedback(data) {
	    if (data.editing_manager_feedback()) {
	        let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/edit', {
	            objective_id: data.objective_id,
	            employee_id: this.logged_in_employee(),
	            feedback: data.manager_feedback
	        });
	        if (res.status == 'ERROR')
	            Grape.alerts.apiError(res);
	        if (res.status == 'OK') {
	            Grape.alerts.alert({type: 'success', message: 'Successfully updated your feedback.'});
	            this.dialog.get_obj_details(this.objective_plan());
	            data.editing_manager_feedback(!data.editing_manager_feedback());
	        } else
	            Grape.alerts.alert({type: 'error', message: 'An error occurred while updated feedback.'});
	    } else {
	        data.editing_manager_feedback(!data.editing_manager_feedback());
	    }
	}
	
	async btn_cancel_delete_feedback(data) {
	    if (data.editing_emp_feedback())
	        data.editing_emp_feedback(!data.editing_emp_feedback());
	    else if (data.editing_manager_feedback())
	        data.editing_manager_feedback(!data.editing_manager_feedback());
	    else if (!data.editing_emp_feedback() && !data.editing_manager_feedback()) {
	        let response = await Grape.alerts.confirm({ 
	            type: 'warning', 
	            message: 'Are you sure you want to remove this feedback?'
	        });
	        if (response) {
	            let res = await Grape.fetches.postJSON('/performance_management/objective_feedback/remove', { 
	                objective_feedback_id: data.objective_feedback_id,
	                employee_id: this.logged_in_employee(),
	                feedback: ''
	            });
	            if (res.status == 'ERROR')
	                Grape.alerts.apiError(res);
	            else {
	                Grape.alerts.alert({type: 'Success', message: 'Successfully removed feedback'});
	                this.dialog.get_obj_details(this.objective_plan());
	            }
	        }
	    }
	}
	
	async btn_cancel_remove_objective(data) {
	    if (data.editing()) {
	        data.editing(!data.editing());
	    } else {
	        let response = await Grape.alerts.confirm({ 
	            type: 'warning', 
	            message: 'Are you sure you want to remove this objective?'
	        });
	        if (response) {
	            let res = await Grape.fetches.postJSON('/performance_management/objective/remove_from_plan', { 
	                objective_id: data.objective_id 
	            });
	            if (res.status == 'ERROR')
	                Grape.alerts.apiError(res);
	            else {
	                Grape.alerts.alert({type: 'Success', message: 'Successfully removed objective'});
	                this.dialog.get_obj_details(this.objective_plan());
	            }
	        }
	    }
	}
	
	async move_order_up(data) {
	    let sequence;
	    if (data.sequence > 1)
	        sequence = parseInt(data.sequence) - 1;
	    else
	        sequence = data.sequence;
	    try {
	        let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
	            objective_id: data.objective_id,
	            sequence: sequence
	        });
	        if (res.status != 'ERROR')
	            this.dialog.get_obj_details(this.objective_plan());
	    } catch (error) {
	        console.error(error);
	    }
	}
	
	async move_order_down(data) {
	    let sequence = parseInt(data.sequence) + 1;
	    try {
	        let res = await Grape.fetches.postJSON('/performance_management/objective/edit', {
	            objective_id: data.objective_id,
	            sequence: sequence
	        });
	        if (res.status != 'ERROR')
	            this.dialog.get_obj_details(this.objective_plan());
	    } catch (error) {
	        console.error(error);
	    }
	}
	
	async btn_edit_linked_comp_objectives(data) {
	    let res = await Grape.dialog.open('LinkCompanyObjectives', { 
	        data: data, 
	        to_add: null, 
	        to_remove: null, 
	        editing: true, 
	        linked_comp_objectives: data.linked_company_objectives() || []
	    });
	    this.dialog.get_obj_details(this.objective_plan());
	}

	// Helper method to get employee object from display name
	get_employee_display_name(displayName) {
	if (this.has_admin_access()) {
		// Admin users: find by actual name
		return this.available_employees().find(emp => 
			`${emp.firstname} ${emp.surname}` === displayName);
	} else {
		// Non-admin users: find by index (Employee 1, Employee 2, etc.)
		const match = displayName.match(/Employee (\d+)/);
		if (match) {
			const index = parseInt(match[1]) - 1;
			return this.available_employees()[index];
		}
	}
	return null;
}

	// Add peers to the group
	btn_add_peers_click() {
		if (this.selected_available_employees().length === 0) return;
		
		let selected_employees = this.selected_available_employees().map(name => {
			return this.get_employee_display_name(name);
		}).filter(Boolean); // Filter out any undefined values
		
		// Add to peer group
		this.peer_group_employees.push(...selected_employees);
		
		// Remove from available employees
		this.available_employees(this.available_employees().filter(emp => 
			!selected_employees.some(selected => selected.employee_id === emp.employee_id)
		));
		
		// Clear selection
		this.selected_available_employees([]);
	}

	// Remove peers from the group
	btn_remove_peers_click() {
		if (this.selected_group_employees().length === 0) return;
		
		let selected_employees = this.selected_group_employees().map(name => {
			// Remove trailing space from the name if any
			let fullName = name.trim();
			// Find the employee in peer_group_employees
			return this.peer_group_employees().find(emp => 
				`${emp.firstname} ${emp.surname}` === fullName
			);
		}).filter(Boolean); // Filter out any undefined values
		
		// Add back to available employees
		this.available_employees.push(...selected_employees);
		
		// Remove from peer group
		this.peer_group_employees(this.peer_group_employees().filter(emp => 
			!selected_employees.some(selected => selected.employee_id === emp.employee_id)
		));
		
		// Clear selection
		this.selected_group_employees([]);
	}

	async load_peers_for_cycle() 
	{
		console.log('selected performance cycle', this.selected_performance_cycle());

	try {
		// Load all peer members for the selected performance cycle
		let peer_members_res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_peer_group',
			schema: 'perfm_manage',
			fields: ['employee_id', 'full_name', 'peer_member_id', 'performance_cycle_id', 'peer_group_id'],
			filter: [{
				field: 'performance_cycle_id',
				operand: '=',
				value: this.selected_performance_cycle()
			}]
		});
		console.log('peer_member_results', peer_members_res);
		let existing_members = [];
		if (peer_members_res.total !== 0 && peer_members_res.records && Array.isArray(peer_members_res.records)) {
			// Remove duplicates from existing members based on employee_id
			const uniqueMembers = new Map();
			peer_members_res.records.forEach(member => {
				if (!uniqueMembers.has(member.employee_id)) {
					// Parse the full_name to get firstname and surname
					const nameParts = member.full_name ? member.full_name.split(' ') : ['', ''];
					const firstname = nameParts[0] || '';
					const surname = nameParts.slice(1).join(' ') || '';
					
					uniqueMembers.set(member.employee_id, {
						employee_id: member.employee_id,
						firstname: firstname,
						surname: surname,
						peer_member_id: member.peer_member_id,
						performance_cycle_id: member.performance_cycle_id,
						cycle_name: member.cycle_name
					});
				}
			});
			existing_members = Array.from(uniqueMembers.values());

			// Enable peer group functionality
			this.add_peer_group(true);

			// Set the peer group employees (automatically populated)
			this.peer_group_employees(existing_members);

			// Load remaining available employees (excluding current peers)
			await this.load_department_employees_for_edit();
		}
		else {
			// No peers found for this performance cycle
			this.peer_group_employees([]);
			await this.load_department_employees();
		}
	} catch (error) {
		console.error('Error loading peers for cycle:', error);
		Grape.alerts.alert({ 
			type: 'error', 
			message: 'An error occurred while loading peers for the selected performance cycle: ' + error.message 
		});
	}
}



	// Load employees based on admin access - all employees or department employees
	async load_department_employees() {
		try {
			let options = {
				table: 'v_active_employees_department',
				schema: 'savanna',
				limit: 1000000,
				fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id']
			};

			// If user doesn't have admin access, filter by department
			if (!this.has_admin_access()) {
				let department_id;
				
				if (this.employment_info() && this.employment_info().employment_info && 
					this.employment_info().employment_info.length > 0 && 
					this.employment_info().employment_info[0].department_id) {
					department_id = this.employment_info().employment_info[0].department_id;
				} else {
					Grape.alerts.alert({ type: 'warning', message: 'Unable to determine department for loading employees.' });
					return;
				}

				options.filter = [{
					field: 'department_id',
					operand: '=',
					value: department_id
				}];
			} else {
				// For admin access, load all employees (no filter)
				options.filter = [{}];
			}
			
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status != 'ERROR' && res.records && Array.isArray(res.records)) {
				// Get current employee ID to exclude from available employees
				const currentEmployeeId = this.employment_info() ? this.employment_info().employee_id : null;
				
				// Filter out the current employee from available employees
				const availableEmployees = res.records.filter(emp => 
					!(currentEmployeeId && emp.employee_id === currentEmployeeId)
				);
				
				// Set available employees
				this.available_employees(availableEmployees || []);
				
				// Initialize peer group employees as empty (no existing peer group)
				this.peer_group_employees([]);
				
				// Clear selections
				this.selected_available_employees([]);
				this.selected_group_employees([]);
			} else {
				// Handle case where no records are returned
				this.available_employees([]);
				this.peer_group_employees([]);
				this.selected_available_employees([]);
				this.selected_group_employees([]);
				
				if (res.status === 'ERROR') {
					Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees.' });
				}
			}
		} catch (error) {
			console.error(error);
			// Reset arrays to prevent undefined errors
			this.available_employees([]);
			this.peer_group_employees([]);
			this.selected_available_employees([]);
			this.selected_group_employees([]);
			
			Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees: ' + error.message });
		}
	}
	
	// Updated load_peer_group_employees method with admin access consideration
	async load_peer_group_employees() {
	if (!this.selected_group()) return;

	try {
		let options = {
			table: 'v_active_employees_department',
			schema: 'savanna',
			limit: 1000000,
			fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id']
		};

		// If user doesn't have admin access, filter by department
		if (!this.has_admin_access()) {
			let department_id;
			
			if (this.employment_info() && this.employment_info().employment_info && 
				this.employment_info().employment_info.length > 0 && 
				this.employment_info().employment_info[0].department_id) {
				// Use department_id from bindings employee_info (nested in employment_info array)
				department_id = this.employment_info().employment_info[0].department_id;
			} else {
				// Fall back to peer group's department_id
				let selected_peer_group = this.peer_group().find(group => group.peer_group_id === this.selected_group());
				if (!selected_peer_group) return;
				department_id = selected_peer_group.department_id;
			}

			options.filter = [{
				field: 'department_id',
				operand: '=',
				value: department_id
			}];
		} else {
			// For admin access, load all employees (no filter)
			options.filter = [{}];
		}
		
		let res = await Grape.fetches.getJSON('/api/record', options);
		if (res.status != 'ERROR' && res.records && Array.isArray(res.records)) {
			// Load existing peer group members from the v_peer_group view
			let peer_group_filter = [{
				field: 'peer_group_id',
				operand: '=',
				value: this.selected_group()
			}];

			console.log('performance cycle id ', this.selected_performance_cycle());
			
			// Don't filter by performance cycle when loading peer group members
			// This allows all peer group members to be loaded regardless of cycle
			
			let existing_members_res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_peer_group',
				schema: 'perfm_manage',
				fields: ['employee_id', 'full_name', 'peer_member_id', 'performance_cycle_id', 'cycle_name'],
				filter: peer_group_filter,
				filter_join: 'AND'
			});

			let existing_members = [];
			if (existing_members_res.status != 'ERROR' && existing_members_res.records && Array.isArray(existing_members_res.records)) {
				// Remove duplicates from existing members based on employee_id
				const uniqueMembers = new Map();
				existing_members_res.records.forEach(member => {
					if (!uniqueMembers.has(member.employee_id)) {
						// Parse the full_name to get firstname and surname
						const nameParts = member.full_name ? member.full_name.split(' ') : ['', ''];
						const firstname = nameParts[0] || '';
						const surname = nameParts.slice(1).join(' ') || '';
						
						uniqueMembers.set(member.employee_id, {
							employee_id: member.employee_id,
							firstname: firstname,
							surname: surname,
							peer_member_id: member.peer_member_id,
							performance_cycle_id: member.performance_cycle_id,
							cycle_name: member.cycle_name
						});
					}
				});
				existing_members = Array.from(uniqueMembers.values());
			}

			// Filter out employees already in the peer group
			// Also exclude the current employee from available employees
			const currentEmployeeId = this.employment_info() ? this.employment_info().employee_id : null;
			const availableEmployees = res.records.filter(emp => 
				!existing_members.some(member => member.employee_id === emp.employee_id) &&
				!(currentEmployeeId && emp.employee_id === currentEmployeeId)
			);
			
			// Set available employees
			this.available_employees(availableEmployees || []);
			
			// Set current peer group members
			this.peer_group_employees(existing_members || []);
			
			// Clear selections
			this.selected_available_employees([]);
			this.selected_group_employees([]);
		} else {
			// Handle case where no records are returned
			this.available_employees([]);
			this.peer_group_employees([]);
			this.selected_available_employees([]);
			this.selected_group_employees([]);
			
			if (res.status === 'ERROR') {
				Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees.' });
			}
		}
	} catch (error) {
		console.error(error);
		// Reset arrays to prevent undefined errors
		this.available_employees([]);
		this.peer_group_employees([]);
		this.selected_available_employees([]);
		this.selected_group_employees([]);
		
		Grape.alerts.alert({ type: 'error', message: 'An error occurred while loading employees: ' + error.message });
	}
}

	close()
	{
		this.dialog.close(this.current_step_sequence());
	}

	update_status()
	{
	    if (!this.current_step_sequence() || !this.total_steps())
	    {
	        this.status('Not Started');
	        return;
	    }

	    if (this.current_step_sequence() >= 1 && this.current_step_sequence() <= this.total_steps()) 
	        this.status('In Progress');
	    else if (this.current_step_sequence() > this.total_steps())
	        this.status('Completed');
	    else
	        this.status('Not Started');
	}

	async btn_save() {
	    if (!this.objective_name()) {
	        Grape.alerts.alert({ type: 'warning', message: 'Objective Plan name cannot be empty!' });
	        return;
	    }
	    else {
	        let requestData = {
	            objective_plan_id: this.objective_plan_id() || null,
	            name: this.objective_name(),
	            employee_id: this.employment_info().employee_id,
	            cycle_id: this.selected_performance_cycle(),
	            due_date: this.due_date(),
	            setup_date: this.setup_date(),
	            status: this.status(),
	            current_step: this.current_step_sequence(),
	            rating_system_id: this.selected_rating_system(),
	            description: this.description()
	        };
		
	        // Add peer group data if enabled
	        if (this.add_peer_group()) {
	            if (this.selected_group()) {
	                requestData.peer_group_id = this.selected_group();
	            }
	            requestData.peer_members = this.peer_group_employees().map(emp => ({
	                employee_id: emp.employee_id,
	                peer_member_id: emp.peer_member_id || null
	            }));
	        }
		
	        console.log('request data', requestData);
		
	        let res = await Grape.fetches.postJSON('/performance_management/objective_plan/edit', requestData);
		
	        if (res.status != 'ERROR') {
	            // Update the status after successful save
	            this.update_status();
			
	            Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Successfully saved Objective Plan' });
	            this.dialog.close(this.current_step_sequence());
	        }
	        else
	            Grape.alerts.alert({ type: 'error', message: 'An error occurred while saving the Objective Plan' });
	    }
	}

	async btn_delete_plan()
	{
		let response = await Grape.alerts.confirm({type: 'warning', message: `Are you sure you want to delete ${this.objective_name()}?`});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/remove', {objective_plan_id: this.objective_plan_id()});
			if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: 'Successfully deleted'});
				this.dialog.close(true);
			}
			else
				Grape.alerts.alert({type: 'error', message: 'An error occurred while deleting the Objective Plan'});
		}
	}

	async btn_mark_stage_done()
	{
		let response = await Grape.alerts.confirm({ type: 'warning', message: `Mark "${this.current_step()}" as done?` });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/performance_management/objective_plan/edit', {
				objective_plan_id: this.objective_plan_id(),
				current_step: this.current_step_sequence() + 1
			});
			if (res.status == 'ERROR') 
				Grape.alerts.apiError(res);
			
			else if (res.status == 'OK')
			{
				let is_completed = await this.dialog.update_current_step();
				// Only show the success alert if the plan isn't completed
				if (!is_completed) 
					Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Stage/step successfully updated' });
			}
			else 
				Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred while updating current stage/step' });
		}
	}

	async load_existing_peer_members() {
	if (!this.objective_plan_id()) return;

	try {
		// First, check if there are any peer members for this objective plan
		let peer_member_res = await Grape.fetches.getJSON('/api/record', {
			table: 'peer_member',
			schema: 'perfm_manage',
			fields: ['employee_id', 'peer_member_id', 'objective_plan_id', 'peer_group_id'],
			filter: [{
				field: 'objective_plan_id',
				operand: '=',
				value: this.objective_plan_id()
			}]
		});

		console.log('peers', peer_member_res);

		if (peer_member_res.status !== 'ERROR' && peer_member_res.records && peer_member_res.records.length > 0) {
			// Enable peer group functionality
			this.add_peer_group(true);

			// Get employee details for the peer members
			const employee_ids = peer_member_res.records.map(member => member.employee_id);
		
			if (employee_ids.length > 0) {
				let employee_details_res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_active_employees_department',
					schema: 'savanna',
					fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id'],
					filter: [{
						field: 'employee_id',
						operand: 'IN',
						value: employee_ids
					}]
				});

				if (employee_details_res.status !== 'ERROR' && employee_details_res.records) {
					// Map peer member IDs to employee details
					const peer_employees = employee_details_res.records.map(emp => {
						const peer_member = peer_member_res.records.find(pm => pm.employee_id === emp.employee_id);
						return {
							...emp,
							peer_member_id: peer_member ? peer_member.peer_member_id : null,
							peer_group_id: peer_member ? peer_member.peer_group_id : null
						};
					});

					// Set the peer group employees
					this.peer_group_employees(peer_employees);
				
					// Load employees for the available list (excluding current peer members and current employee)
					await this.load_department_employees_for_edit();
						} else {
	                    console.error('Failed to load employee details');
	                    this.peer_group_employees([]);
	                    await this.load_department_employees_for_edit();
	                }
	            } else {
	                console.log('No employee IDs found');
	                this.peer_group_employees([]);
	                await this.load_department_employees_for_edit();
	            }
	        } else {
	            console.log('No peer members found for this objective plan');
	            // No peer members found
	            this.peer_group_employees([]);
	            this.available_employees([]);
		}
	}
	catch (error) {
		console.error('Error loading existing peer members:', error);
		Grape.alerts.alert({ 
			type: 'error', 
			message: 'An error occurred while loading existing peer members: ' + error.message 
		});
	}
}


	// Add this helper method to load employees for edit mode with admin access consideration
	async load_department_employees_for_edit() {
	    try {
	        let options = {
	            table: 'v_active_employees_department',
	            schema: 'savanna',
	            limit: 1000000,
	            fields: ['id_number', 'firstname', 'surname', 'employee_id', 'email', 'date_started', 'department_id']
	        };

	        // If user doesn't have admin access, filter by department
	        if (!this.has_admin_access()) {
	            let department_id;
		
	            if (this.employment_info() && this.employment_info().employment_info && 
	                this.employment_info().employment_info.length > 0 && 
	                this.employment_info().employment_info[0].department_id) {
	                department_id = this.employment_info().employment_info[0].department_id;
	            } else {
	                console.warn('Unable to determine department for loading employees.');
	                return;
	            }

	            options.filter = [{
	                field: 'department_id',
	                operand: '=',
	                value: department_id
	            }];
	        } else {
	            // For admin access, load all employees (no filter)
	            options.filter = [{}];
	        }
		
	        let res = await Grape.fetches.getJSON('/api/record', options);
	        if (res.status !== 'ERROR' && res.records && Array.isArray(res.records)) {
	            // Get current employee ID and existing peer member IDs to exclude
	            const currentEmployeeId = this.employment_info() ? this.employment_info().employee_id : null;
	            const existingPeerMemberIds = this.peer_group_employees().map(emp => emp.employee_id);
			
	            // Filter out the current employee and existing peer members
	            const availableEmployees = res.records.filter(emp => 
	                !(currentEmployeeId && emp.employee_id === currentEmployeeId) &&
	                !existingPeerMemberIds.includes(emp.employee_id)
	            );
			
	            // Set available employees
	            this.available_employees(availableEmployees || []);
			
	            // Clear selections
	            this.selected_available_employees([]);
	            this.selected_group_employees([]);
	        }
	    } catch (error) {
	        console.error('Error loading employees for edit:', error);
	        this.available_employees([]);
	    }
	}
};

class AddObjectivePlanPage
{
	constructor (bindings)
	{
		this.viewModel = new AddObjectivePlanViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();

		// Initialize feature access before other operations
		await this.viewModel.init_feature_access();

		await this.updateData();

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_performance_cycles',
				schema: 'perfm_manage',
				filter: [{}]
			})
			if (res.status != 'ERROR')
				this.viewModel.performance_cycles(res.records);
		} catch (error) {
			console.error(error)
			Grape.alerts.alert({type: 'error', title: 'Error', message : 'An error occurred when loading the Performance Cycles'});
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_peer_group',
				schema: 'perfm_manage',
				filter: [{}]
			});
		
			if (res.status !== 'ERROR') {
				// Remove duplicate peer_group_name entries
				let unique_groups = [];
				let names_seen = new Set();
		
				for (const group of res.records) {
					if (!names_seen.has(group.peer_group_name)) {
						names_seen.add(group.peer_group_name);
						unique_groups.push(group);
					}
				}
		
				this.viewModel.peer_group(unique_groups);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({
				type: 'error',
				title: 'Error',
				message: 'An error occurred when loading the Peer Groups'
			});
		}

		try
		{
    	    let res = await Grape.fetches.getJSON('/api/record', {
    	        table: 'measure',
    	        schema: 'perfm_manage'
    	    });
    	    if (res.status != 'ERROR')
    	        this.viewModel.measures(res.records);
    	} catch (error) {
    	    console.error(error);
    	}


		if (this.bindings)
		{
			console.log('bindings', this.bindings);
			this.viewModel.edit(this.bindings.edit);
			this.viewModel.employment_info(ko.mapping.toJS(this.bindings.employee_info));
			this.viewModel.objective_plan(this.bindings.data);
		}

		if (this.viewModel.edit())
		{

			this.viewModel.cycle_changed(false);
			this.viewModel.setup_date(this.bindings.data.setup_date);
			this.viewModel.title('Edit Objective Plan');
			this.viewModel.selected_rating_system(this.bindings.data.rating_system_id);
			this.viewModel.objective_name(this.bindings.data.name);
			this.viewModel.description(this.bindings.data.description);
			this.viewModel.due_date(this.bindings.data.due_date);
			this.viewModel.objective_plan_id(this.bindings.data.objective_plan_id);
			this.viewModel.selected_performance_cycle(this.bindings.data.performance_cycle_id);

			await this.check_and_load_peer_group();

        	await this.viewModel.load_existing_peer_members();
			//this.viewModel.department_id(this.bindings.)

			await this.get_current_step_rules();
			
			this.get_obj_details(this.bindings.data);
			this.update_current_step();
		}
		else
		{
			this.viewModel.title('Add Objective Plan');
			this.viewModel.cycle_changed(true);
			this.viewModel.setup_date(new Date().toISOString().split('T')[0]);
		}
	}

	async get_current_step_rules()
	{
	    if (this.viewModel.objective_plan() && this.viewModel.selected_performance_cycle())
	    {
	        try {
	            let rules = await PerfManage.get_current_step_rules(
	                this.viewModel.selected_performance_cycle(), 
	                this.bindings.data.current_step, 
	                this.viewModel.employment_info().employee_id
	            );
	            console.log('Fetched rules for current step:', rules);
			
	            // Make sure rules is valid before setting
	            if (rules) {
	                this.viewModel.rules(rules);
	            } else {
	                console.error('Rules returned null or undefined');
	                // Keep default rules if fetch failed
	            }
	        } catch (error) {
	            console.error('Error fetching rules:', error);
	            // Keep default rules on error
	        }
	    }
	}

		async check_and_load_peer_group() {
	    try {
	        // First, check if there are peer members in the peer_member table
	        let peer_member_res = await Grape.fetches.getJSON('/api/record', {
	            table: 'peer_member',
	            schema: 'perfm_manage',
	            fields: ['peer_member_id', 'employee_id', 'objective_plan_id', 'performance_cycle_id', 'peer_group_id'],
	            filter: [{
	                field: 'objective_plan_id',
	                operand: '=',
	                value: this.viewModel.objective_plan_id()
	            }]
	        });

	        console.log('peer_member check:', peer_member_res);

	        if (peer_member_res.status !== 'ERROR' && peer_member_res.records && peer_member_res.records.length > 0) {
	            // Check if any of the peer members have a peer_group_id
	            const peer_group_ids = peer_member_res.records
	                .map(pm => pm.peer_group_id)
	                .filter(id => id != null && id !== '');

	            if (peer_group_ids.length > 0) {
	                // Get the first peer_group_id (assuming all members belong to the same group)
	                const peer_group_id = peer_group_ids[0];

	                // Fetch peer group details from v_peer_group
	                let peer_group_res = await Grape.fetches.getJSON('/api/record', {
	                    table: 'v_peer_group',
	                    schema: 'perfm_manage',
	                    fields: ['peer_group_id', 'peer_group_name', 'description', 'department_id', 'company_id'],
	                    filter: [{
	                        field: 'peer_group_id',
	                        operand: '=',
	                        value: peer_group_id
	                    }]
	                });

	                console.log('peer_group details:', peer_group_res);

	                if (peer_group_res.status !== 'ERROR' && peer_group_res.records && peer_group_res.records.length > 0) {
	                    this.viewModel.add_peer_group(true);
					
	                    this.viewModel.loading_edit_mode(true);
	                    this.viewModel.selected_group(peer_group_id);
	                    this.viewModel.loading_edit_mode(false);
	                }
	            } else {
	                // Peer members exist but no peer group assigned
	                this.viewModel.add_peer_group(true);
	                console.log('Peer members found without peer group assignment');
	            }
	        }
	    } catch (error) {
	        console.error('Error checking peer group:', error);
	        Grape.alerts.alert({ 
	            type: 'error', 
	            message: 'An error occurred while checking for peer group: ' + error.message 
	        });
	    }
	}

	async update_current_step()
	{
		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_objective_plans',
				schema: 'perfm_manage',
				fields: ['current_step', 'current_step_name'],
				filter: [
					{
						field: 'objective_plan_id',
						operand: '=',
						value: this.viewModel.objective_plan_id()
					}
				]
			});

			if (res.records[0].current_step_name == null)
			{
				Grape.alerts.alert({ type: 'success', title: 'Objective Plan Completed', message: 'The Objective Plan is now completed.' });
				this.viewModel.close();
				return true; // Indicate that the plan is completed
			}

			if (res.status != 'ERROR')
			{
				this.viewModel.current_step(res.records[0].current_step_name);
				this.viewModel.current_step_sequence(res.records[0].current_step);
			}
			return false; // Indicate that the plan is not completed
		} catch (error)
		{
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: 'An error occurred when loading the steps for the selected Performance Cycle' });
			return false;
		}
	}

	async updateData()
	{
		let options = {
			table: 'v_rating_methods',
			schema: 'perfm_manage',
			filter_join: 'AND',
			filter: [{
				field: 'active',
				operand: '=',
				value: true
			}]
		}
		if (this.viewModel.selected_rating_type())
		{
			options.filter.push({
				field: 'rating_method_type',
				operand: '=',
				value: this.viewModel.selected_rating_type()
			});
		}

		try {
			// API to get the available rating systems to choose from
			let res = await Grape.fetches.getJSON('/api/record', options);

			if (res.status != 'ERROR')
				this.viewModel.rating_systems(res.records);

		} catch (error) {
			console.error(error)
			Grape.alerts.alert({type: 'error', title: 'Error', message : 'An error occurred when loading the Rating Systems'});
		}
	}

	async get_cycle_dates(id)
	{
		let selected_cycle = this.viewModel.performance_cycles().find(cycle => cycle.performance_cycle_id === id);
		if (selected_cycle)
			this.viewModel.cycle_dates(selected_cycle.from_date + ' until ' + selected_cycle.to_date);

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_cycle_stages',
				schema: 'perfm_manage',
				filter_join: 'AND',
				filter: [{
					field: 'performance_cycle_id',
					operand: '=',
					value: id
				}]
			});

			if (res.status !== 'ERROR')
			{
				if (res.records.length > 0)
				{
					let steps = res.records.sort((a, b) => a.step_sequence - b.step_sequence);
					this.viewModel.current_step(steps[0].name);
					this.viewModel.current_step_sequence(steps[0].step_sequence);
					this.viewModel.total_steps(steps.length);
					this.viewModel.update_status();
				}
				else
					this.viewModel.current_step(null);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', message: 'An error occurred while loading the performance cycle stages.'});
		}
	}

	async get_obj_details(data)
	{
	    if (data)
	    {
	        let objective_plan_id = parseInt(this.bindings.data.objective_plan_id);
	        let res = await Grape.fetches.getJSON('/api/record', {
	            table: 'v_objectives_for_objective_plan',
	            schema: 'perfm_manage',
	            sort_order: 'ASC',
	            sort_field: 'sequence',
	            filter: [{
	                field: 'objective_plan_id',
	                operand: '=',
	                value: objective_plan_id
	            }]
	        });
	        if (res.status != 'ERROR')
	        {
	            let items = res.records.map((x) => ({
	                ...x,
	                editing: ko.observable(false),
	                editing_emp_feedback: ko.observable(false),
	                editing_manager_feedback: ko.observable(false),
	                // Initialize status observables
	                status: ko.observable(x.status || 'New'),
	                selected_status: ko.observable(x.status || 'New'),
	                status_update_visible: ko.observable(false),
				
	                // Toggle function for status update visibility
	                toggleStatusUpdate: function() {
	                    this.status_update_visible(!this.status_update_visible());
	                    if (this.status_update_visible()) {
	                        this.selected_status(this.status());
	                    }
	                },
				
	                linked_company_objectives: ko.observable((x.linked_company_objectives || []).map((x) => ({
	                    ...x,
	                    display_name: x.number + ' ' + x.description
	                })))
	            }));
	            // Ensure proper numeric sorting by sequence
	            items.sort((a, b) => {
	                return parseInt(a.sequence) - parseInt(b.sequence);
	            });
	            this.viewModel.objectives(items);
	        }
	    }
	}
};

export default {
	name: 'AddObjectivePlan',
	dialog_class: AddObjectivePlanPage,
	template: template,
	template_filename: 'translation/dialogs/add_objective_plan',
	provider: 'ps'
};